import { DialogActions, DialogContent } from "@mui/material";
import {
  Autocomplete,
  Button,
  Field,
  FieldsContainer,
  Form,
  PageHeader, Switch,
  TextField,
} from "common";
import I18n from "i18n-js";
import useOpenapiKeyForm, { UseOpenapiKeyFormProps } from "./useOpenapiKeyForm";
export interface OpenapiFormProps extends UseOpenapiKeyFormProps {
  disabled?: boolean;
}

export default function OpenapiKeyForm({
  id,
  afterSave,
  onClose,
  disabled,
}: OpenapiFormProps) {
  const {
    item,
    options,
    errors,
    loading,
    isDirty,
    isCreate,
    getIsDirty,
    getRequiredFields,
    onChange,
    save,
    saving,
  } = useOpenapiKeyForm({
    id,
    afterSave,
  });

  const title = isCreate
    ? I18n.t("OpenapiKey.addTitle")
    : I18n.t("OpenapiKey.editTitle");
  return (
    <>
      <PageHeader title={title} onClose={onClose}>
        <Switch
          id="enabled"
          label={I18n.t("OpenapiKey.attributes.enabled")}
          value={!!item.enabled}
          numeric
          onChange={(evt: any) =>
            onChange({ enabled: evt.target.value ? 1 : 0 } as any, "enabled")
          }
        />
      </PageHeader>
      <DialogContent>
        <Form
          loading={loading}
          item={item}
          options={options}
          errors={errors}
          onChange={onChange}
          translationCategory="OpenapiKey.attributes"
          isDirty={getIsDirty}
          requiredFields={getRequiredFields()}
          disabled={disabled}
        >
          <FieldsContainer>
            <Field fullWidth>
              <TextField id="name" />
            </Field>
            <Field fullWidth>
              <Autocomplete
                id="permissions"
                multiple
                getOptionDisabled={(option: any) => {
                  const selectedOptions = item.permissions;
                  const allOptions = options.permissions;
                  const currentPermission = option.value;
                  const match = currentPermission.match(/^openapi(View|Add|Modify)(.+)$/);

                  if (match && match[1] && match[2]) {
                    const [type, permission] = [match[1], match[2]];

                    if (type !== "View") {
                      return false;
                    }

                    const addPermissionValue = "openapiAdd" + permission;
                    const modifyPermissionValue = "openapiModify" + permission;

                    let otherTypeFound = false;

                    allOptions.forEach((option) => {
                      if (option.value === addPermissionValue || option.value === modifyPermissionValue) {
                        otherTypeFound = true;
                      }
                    });

                    if (!otherTypeFound) {
                      return false;
                    }

                    return selectedOptions
                      && (
                        selectedOptions.includes(addPermissionValue)
                        || selectedOptions.includes(modifyPermissionValue)
                      );
                  }

                  return false;
                }}
              />
            </Field>
          </FieldsContainer>
        </Form>
      </DialogContent>
      <DialogActions>
        <Button
          title={I18n.t("App.save")}
          disabled={!isDirty}
          onClick={() => save()}
          loading={saving}
        />
      </DialogActions>
    </>
  );
}
